import { notiDataService } from ".";
import { hideAlert, showAlert } from "../../../components/alert/Alert";
import { AlertTypeEnum } from "../../../enums";
import {
  IDeleteSingleArgs,
  IGetSingleArgs,
  IPageAndSearchArgs,
  ISearchArgs,
  IUpdateSingleArgs,
} from "../../../interfaces";
import { goFetch } from "../../../utilities/goFetch";

let itemId = ["cards", "users", "rewards", "goal types"];
let itemDesc = ["By Cards", "By Users", "By Rewards", "By Goal Types"];

let dataInUse: any;
let cards: any;
let users: any;
let rewards: any;
let goalTypes: any;
class Service {
  async getByPage({ search, pageNo }: IPageAndSearchArgs) {
    let jsonResponse: any;

    if (!dataInUse) {
      jsonResponse = {
        data: [
          {
            _id: itemId[0],
            name: itemDesc[0],
          },
          {
            _id: itemId[1],
            name: itemDesc[1],
          },
          {
            _id: itemId[2],
            name: itemDesc[2],
          },
          {
            _id: itemId[3],
            name: itemDesc[3],
          },
        ],
      };

      dataInUse = jsonResponse.data;
    }

    return {
      pageNo: pageNo,
      pageSize: 10,
      pageCount: 1,
      data: dataInUse,
      itemCount: dataInUse.length,
    };
  }

  async getSingle({ key }: IGetSingleArgs) {
    if (dataInUse) {
      let singlePage = dataInUse.filter((d: any) => d._id === key)[0];

      if (!singlePage || !singlePage._id) return;

      switch (singlePage._id) {
        case itemId[0]:
          singlePage["listCards"] = [
            { label: "Test2", value: 1 },
            { label: "Test3", value: 2 },
          ];

          if (!cards) await notiDataService.getAllCards();
          if (cards) {
            let listCardsName = [];
            for (let index = 0; index < cards.length; index++) {
              const element = cards[index];
              listCardsName.push({
                label: element["name"],
                _id: element["_id"],
              });
            }
            singlePage["listCards"] = listCardsName;
            singlePage["listDesc"] = "Card";
          }
          break;

        case itemId[1]:
          singlePage["listCards"] = [
            { label: "Test2", value: 1 },
            { label: "Test3", value: 2 },
          ];

          if (!users) await notiDataService.getAllUsers();

          if (users) {
            let listUser = [];
            for (let index = 0; index < users.length; index++) {
              const element = users[index];
              if (element["email_address"] !== "-")
                listUser.push({
                  label: element["email_address"],
                  _id: element["_id"],
                });
            }
            singlePage["listCards"] = listUser;
            singlePage["listDesc"] = "User";
          }
          break;

        case itemId[2]:
          singlePage["listCards"] = [
            { label: "Test2", value: 1 },
            { label: "Test3", value: 2 },
          ];
          if (!rewards) await notiDataService.getAllRewards();

          if (rewards) {
            let listCardsName = [];
            for (let index = 0; index < rewards.length; index++) {
              const element = rewards[index];
              listCardsName.push({
                label: element["main_program"],
                _id: element["main_program"],
              });
            }
            singlePage["listCards"] = listCardsName;
            singlePage["listDesc"] = "Reward";
          }
          break;

        case itemId[3]:
          singlePage["listCards"] = [
            { label: "Test2", value: 1 },
            { label: "Test3", value: 2 },
          ];
          if (!goalTypes) await notiDataService.getAllGoalTypes();
          if (goalTypes) {
            let listCardsName = [];
            for (let index = 0; index < goalTypes.length; index++) {
              const element = goalTypes[index];
              listCardsName.push({
                label: element["type"],
                _id: element["_id"],
              });
            }
            singlePage["listCards"] = listCardsName;
            singlePage["listDesc"] = "Goal Type";
          }
          break;

        default:
          break;
      }

      return singlePage;
    }
  }

  async search({ search }: ISearchArgs) {
    return dataInUse.filter((d: any) => new RegExp(search).test(d.name));
  }

  async update({ key, ...rest }: IUpdateSingleArgs) {}

  async delete({ key }: IDeleteSingleArgs) {}

  async addNoti(mess: string, valueID: string, id: string, title: string) {
    switch (id) {
      case itemId[0]:
        await notiDataService.addCardsNoti(valueID, mess, title);
        break;

      case itemId[1]:
        await notiDataService.addUserNoti(valueID, mess, title);
        break;

      case itemId[2]:
        await notiDataService.addRewardsNoti(valueID, mess, title);
        break;

      case itemId[3]:
        await notiDataService.addGoalTypesNoti(valueID, mess, title);
        break;

      default:
        break;
    }

    return true;
  }

  async addGoalTypesNoti(
    valueID: string,
    notiMessage: string,
    notiTitle: string
  ) {
    const res: any = await goFetch(`/admin/notifications/custom/ByGoalTypes`)
      .withBody({
        goalTypeId: valueID,
        notiMessage: notiMessage,
        notiTitle: notiTitle,
      })
      .post();

    if (res["success"]) {
      showAlert({
        content: "Successfully send",
        options: {
          actions: [
            {
              text: "Okay",
              onClick: () => {
                hideAlert();
                return true;
              },
              primary: true,
            },
          ],
          type: AlertTypeEnum.Info,
        },
      });
    }
  }

  async addRewardsNoti(
    valueID: string,
    notiMessage: string,
    notiTitle: string
  ) {
    const res: any = await goFetch(`/admin/notifications/custom/ByRewards`)
      .withBody({
        rewardsId: valueID,
        notiMessage: notiMessage,
        notiTitle: notiTitle,
      })
      .post();

    if (res["success"]) {
      showAlert({
        content: "Successfully send",
        options: {
          actions: [
            {
              text: "Okay",
              onClick: () => {
                hideAlert();
                return true;
              },
              primary: true,
            },
          ],
          type: AlertTypeEnum.Info,
        },
      });
    }
  }

  async addCardsNoti(cardId: string, notiMessage: string, notiTitle: string) {
    const res: any = await goFetch(`/admin/notifications/custom/ByCards`)
      .withBody({
        cardId: cardId,
        notiMessage: notiMessage,
        notiTitle: notiTitle,
      })
      .post();

    if (res["success"]) {
      showAlert({
        content: "Successfully send",
        options: {
          actions: [
            {
              text: "Okay",
              onClick: () => {
                hideAlert();
                return true;
              },
              primary: true,
            },
          ],
          type: AlertTypeEnum.Info,
        },
      });
    }
  }

  async addUserNoti(userId: string, notiMessage: string, notiTitle: string) {
    const res: any = await goFetch(`/admin/notifications/custom/ByUsers`)
      .withBody({
        userId: [userId],
        notiMessage: notiMessage,
        notiTitle: notiTitle,
      })
      .post();

    if (res["success"]) {
      showAlert({
        content: "Successfully send",
        options: {
          actions: [
            {
              text: "Okay",
              onClick: () => {
                hideAlert();
                return true;
              },
              primary: true,
            },
          ],
          type: AlertTypeEnum.Info,
        },
      });
    }
  }

  async getAllCards() {
    const res: any = await goFetch(`/cards/getAllCards`).get();

    if (res["success"]) {
      cards = res["data"];
      return res;
    }

    return [];
  }

  async getAllGoalTypes() {
    const res: any = await goFetch(`/goals/get/types`).get();

    if (res["success"]) {
      goalTypes = res["data"];
      return res;
    }

    return [];
  }

  async getAllRewards() {
    const res: any = await goFetch(`/rewards/getMainProgrammes`).get();

    if (res["success"]) {
      rewards = res["data"];
      return res;
    }

    return [];
  }

  async getAllUsers() {
    const res: any = await goFetch(`/account/all/users`).get();

    if (res["success"]) {
      users = res["data"];
      return res;
    }

    return [];
  }
}

export default new Service();
